export default __webpack_public_path__ + "static/media/10-100.ae865399.jpg";